// src/components/MobileBottomNav.js
import React from 'react';
import { motion } from 'framer-motion';
import { Activity, Users, BarChart3, Plus } from 'lucide-react';
import './MobileBottomNav.css';

const MobileBottomNav = ({ currentView, onNavigate, onAddPatient }) => {
  const navItems = [
    { id: 'dashboard', label: 'Dashboard', icon: Activity },
    { id: 'patients', label: 'Patients', icon: Users },
    { id: 'reports', label: 'Reports', icon: BarChart3 },
  ];

  return (
    <motion.nav 
      className="mobile-bottom-nav"
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      transition={{ type: "spring", damping: 25, stiffness: 200 }}
    >
      {navItems.map((item) => {
        const Icon = item.icon;
        const isActive = currentView === item.id;
        
        return (
          <motion.button
            key={item.id}
            className={`nav-item ${isActive ? 'active' : ''}`}
            onClick={() => onNavigate(item.id)}
            whileTap={{ scale: 0.9 }}
          >
            <div className="nav-icon">
              <Icon size={22} />
              {isActive && (
                <motion.div 
                  className="active-indicator"
                  layoutId="mobile-active-indicator"
                  transition={{ type: "spring", stiffness: 300, damping: 30 }}
                />
              )}
            </div>
            <span className="nav-label">{item.label}</span>
          </motion.button>
        );
      })}
      
      {/* Floating Action Button */}
      <motion.button
        className="fab"
        onClick={onAddPatient}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
      >
        <Plus size={24} />
      </motion.button>
    </motion.nav>
  );
};

export default MobileBottomNav;